import { z } from 'zod';
import { IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const AuditEventSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    actorIdentityId: IdSchema.nullable(),
    actorDisplayName: z.string().nullable(),
    action: z.string(),
    targetType: z.string(),
    targetId: IdSchema.nullable(),
    requestId: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()),
    createdAt: TimestampSchema,
});
export const AuditEventListSchema = z.strictObject({
    items: z.array(AuditEventSchema),
    page: PageInfoSchema,
});
